import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "src/http";
import { configuration } from "../../../configuration";
import { FetchError } from "../../types";
import { useAccessToken } from "../../use-access-token";

type Variables = {
  meetingGuid: string;
};

const useEndMeetingRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function endMeetingRequest(variables: Variables): Promise<void> {
    const accessToken = await getAccessToken();

    const response = await fetch(`${configuration.apiRootUrl}/meetings/${variables.meetingGuid}/end`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: "put",
    });

    if (!response.ok) {
      throw new FetchError(response);
    }
  }

  return { endMeetingRequest };
};

const useEndMeeting = () => {
  const { endMeetingRequest } = useEndMeetingRequest();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: endMeetingRequest,
    onSettled: (_data, _error, variables) => {
      queryClient.removeQueries(queryKeys.meetings.getMeetingsForAllTeams());
      queryClient.removeQueries(queryKeys.meetings.getOneOnOneMeetingsForAllUsers());

      queryClient.invalidateQueries(queryKeys.meetings.getMeetingParticipants(variables.meetingGuid));
      queryClient.invalidateQueries(queryKeys.meetings.getMeeting(variables.meetingGuid));
    },
  });
};

export { useEndMeeting };
